<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <!-- Card header -->
            <div class="card-header py-3 d-flex flex-wrap align-items-center gap-3">
              <h5 class="mb-0">Order Type List</h5>
              <div class="d-flex flex-wrap gap-2 flex-grow-1 justify-content-center">
                <IconField class="search-field">
                  <InputIcon>
                    <i class="pi pi-search" />
                  </InputIcon>
                  <InputText
v-model="table.search" type="text" size="small" placeholder="Search Order Type"
                    class="rounded-pill" style="min-width: 500px;" @keyup="filter" />
                </IconField>
              </div>
            </div>
            <!-- Card Body -->
            <div class="table-responsive" style="height: 500px">
              <table v-if="!table.onLoad" class="table" style="min-width: 100%; width: max-content;">
                <thead class="table-primary">
                  <tr>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Order Type
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Description
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Priority Type
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Created By
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Created At
                    </th>
                  </tr>
                </thead>
                <tbody v-if="table.data.length > 0">
                  <tr v-for="order in table.data" :key="order.id">
                    <td class="text-sm py-3 px-4 value-table-wrapped">
                      {{ order.order_type }}
                    </td>
                    <td class="text-sm py-3 px-4 value-table-wrapped">
                      {{ order.order_type_description }}
                    </td>
                    <td class="text-sm py-3 px-4 value-table-wrapped">
                      {{ order.priority_type }}
                    </td>
                    <td class="text-sm py-3 px-4 value-table-wrapped">
                      {{ order.created_by }}
                    </td>
                    <td class="text-sm py-3 px-4 value-table-wrapped">
                      {{ formatDate(order.created_at) }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colspan="4">No Data</td>
                  </tr>
                </tbody>
              </table>

              <SkeletonLoading
v-else class="px-4 pt-5" :shapes="[
                { type: 'line', width: '100%', height: '20px' },
                { type: 'line', width: '80%', height: '20px' },
                { type: 'line', width: '60%', height: '20px' },
              ]" />
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination
v-model="table.page.current_pages" :page-count="table.page.total_pages" size="sm"
                  @click="changePage()" />
              </span>
              <span class="float-end">
                {{
                  (table.page.current_pages - 1) * table.page.per_pages +
                  table.data.length
                }}
                of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import moment from "moment";
import api from "@/helpers/api";
import orderTypeService from "@/services/generalMasterData/orderTypeService";

export default {
  components: {
    BasePagination,
    SkeletonLoading,
  },
  data() {
    return {
      loadTimeout: null,
      table: {
        onLoad: true,
        search: this.$route.query.search ? this.$route.query.search : '',
        total: 0,
        data: [],
        page: {
          current_pages: 1,
          per_pages: 100,
        },
      },
    };
  },
  watch: {
    "table.page.current_pages": {
      handler() {
        this.get();
      },
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;

      try {
        const response = await api(
          this,
          orderTypeService.list(this.table.page.current_pages, { search: this.table.search }), false);

        this.table.data = response.data.data;
        this.table.total = response.data.total_items;
        this.table.page = response.data;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      if (this.table.search != this.$route.query.search) {
        clearTimeout(this.table.loadTimeout);
        this.table.loadTimeout = setTimeout(() => {
          if (this.table.search == '') {
            this.$router.push({ query: null })
          } else {
            this.$router.push({ query: { search: this.table.search } })
          }

          this.get()
        }, 500);
      }
    },
    changePage() {
      this.get();
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY, HH:mm");
    },
  },
};
</script>

<style scoped>
/* Tambahkan styling sesuai kebutuhan */
</style>
